import moment from 'moment';
import { dropLogistica, dropModelo, dropStatusDocumento } from 'utils/drops';

const getNotasFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: ['PENDENTE'],
  },
  {
    name: 'situacao',
    label: 'Situação',
    type: 'select',
    options: drops?.StatusDocumento,
    multiple: true,
  },
  {
    name: 'natureza_operacao',
    label: 'Natureza da Operação',
    type: 'select',
    options: drops?.NaturezaOperacao,
    multiple: true,
  },
  {
    name: 'modelo',
    label: 'Modelo',
    type: 'select',
    options: dropModelo,
    multiple: true,
  },
  {
    name: 'serie',
    label: 'Série',
    type: 'number',
  },
  {
    name: 'marketplace_name',
    label: 'Marketplace',
  },
  {
    name: 'marketplace_package_id',
    label: 'Marketplace Pacote',
  },
  {
    name: 'marketplace_logistica',
    label: 'Marketplace Logística',
    type: 'select',
    options: dropLogistica,
  },
  {
    name: 'dtemissao.i',
    column: 'dtemissao',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: moment().subtract(1, 'months').format('YYYY-MM-DD'),
  },
  {
    name: 'dtemissao.f',
    column: 'dtemissao',
    label: 'Data de Emissão Final',
    type: 'date',
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
    type: 'number',
    initial: true,
  },
  {
    name: 'entidade',
    label: 'Entidade',
    type: 'virtual-select',
    options: drops?.Entidade,
    multiple: true,
  },
  {
    name: 'filial',
    label: 'Filial',
    type: 'virtual-select',
    options: drops?.Filial,
    multiple: true,
  },
  {
    name: 'vldocto',
    label: 'Valor',
    type: 'currency',
  },
  {
    name: 'forma_pagto',
    label: 'Forma de Pagamento',
  },
  {
    name: 'whatsapp',
    label: 'Contato',
  },
  {
    name: 'vendedor',
    label: 'Vendedor',
    type: 'virtual-select',
    options: drops?.EntidadeTipo?.filter(
      (f) => f?.tipo === 'VENDEDOR' || f?.tipo === 'REPRESENTANTE'
    ),
    multiple: true,
  },
  {
    name: 'ped_cliente',
    label: 'Nº do Pedido do Cliente',
  },
  {
    name: 'integra_access_id',
    label: 'Loja',
    type: 'select',
    options: drops?.IntegraAccess,
    multiple: true,
  },
];

export default getNotasFilterFields;
